// External modules
import acHTTPClient from 'services/ACHTTPClient';
import { orderBy } from 'lodash';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getUserByIdErrored = error => {
  return {
    type: constants.GET_USER_BY_ID_ERROR,
    error,
  };
};

const getUsersErrored = error => {
  return {
    type: constants.GET_USERS_ERROR,
    error,
  };
};

const getUserByIdSuccess = user => {
  return {
    type: constants.GET_USER_BY_ID_SUCCESS,
    user: user,
  };
};

const getUsersSuccess = users => {
  const { data = [] } = users;
  let orderedUsers = orderBy(data, ['name'], ['asc']);
  return {
    type: constants.GET_USERS_SUCCESS,
    users: orderedUsers,
  };
};

const getUserById = id => {
  let apiURL = `${experienceAPIURL}/users/${id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getUserByIdErrored(response.statusText));
        }
        dispatch(getUserByIdSuccess(response.data));
      })
      .catch(error => {
        dispatch(getUserByIdErrored(error));
      });
  };
};

const getUsers = () => {
  let apiURL = `${experienceAPIURL}/users`;
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getUsersErrored(response.statusText));
        }
        dispatch(getUsersSuccess(response.data));
      })
      .catch(error => {
        dispatch(getUsersErrored(error));
      });
  };
};

export { getUserById, getUsers };
